module.exports = __webpack_public_path__ + "static/media/step1_14.b557fd88.png";